import { App as AppDesign, ConfigProvider } from 'antd';
import { FC } from 'react';

import { AccountProvider } from '@context';
import { ThemeProvider } from '@emotion/react';
import { ErrorBoundary } from '@sentry/react';
import { GlobalStyles } from '@styles/GlobalStyles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { colors, config } from '@theme';

import AppRouter from './AppRouter';
import { ErrorFallback } from './ErrorFallback';

const queryClient = new QueryClient();

const App: FC = () => (
  <ErrorBoundary fallback={(errorData) => <ErrorFallback {...errorData} />}>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider prefixCls="ui" iconPrefixCls="ui-icon" theme={config}>
        <ThemeProvider
          // @ts-expect-error-next-line
          theme={{ colors }}
        >
          <AppDesign>
            <GlobalStyles />

            <AccountProvider>
              <AppRouter />
            </AccountProvider>
          </AppDesign>
        </ThemeProvider>
      </ConfigProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
